/**
 * @version 1.0alpha
 * @link https://kelnik.gitbooks.io/kelnik-documentation/content/front-end/components/tooltip.html documentation
 */
import template from './tooltip.twig';
import {Utils} from 'common/scripts/utils';

/**
 * Таймаут для анимации пропадания тултипа
 */
let tooltipTimer = null;

export class Tooltip {
    constructor() {
        /**
         * цель, на которой появится тултип
         * @type {Node}
         */
        this.target = null;

        /**
         * Координаты цели
         * относительно всей страницы
         * @type {Object}
         */
        this.targetCoords = {};

        /**
         * DOM нода тултипа
         * @type {null}
         */
        this.tooltip = null;

        /**
         * Шаблон
         */
        this.template = template;

        /**
         * Позиция по x оси (не учитывает габариты тултипа!)
         * @type {number}
         */
        this.x = 0;

        /**
         * Позиция по y оси (Не учитывает габариты тултипа!)
         * @type {number}
         */
        this.y = 0;

        /**
         * Расположение тултипа относительно цели
         * over - над целью
         * under - под целью
         * left - слева от цели
         * right - справа от цели
         * @type {string}
         */
        this.direction = 'under';

        /**
         * Смещение тултипа от цели
         * чем больше цифра, тем дальше тултип будет от цели
         * у нас скейл, поэтому естественный отступ делается margin'ами
         * @type {number}
         */
        this.offset = 0;

        /**
         * Класс пропадающего тултипа
         * @type {string}
         */
        this.removeClass = 'is-remove';

        this.isDesktop = !Utils.isMobile();
    }

    init(options) {
        this.options = options;
        this.target = options.target;
        this.targetCoords = this.getTargetCoords();
        this.direction = options.direction || this.direction;
        this.content = this.target.dataset.content;

        this._bindContext();
        this.bindEvents();
    }

    /**
     * Определяет координаты цели
     * @returns {{top: *, left: *, bottom: *, right: *}} - координаты по всем направлениям
     */
    getTargetCoords() {
        const rect = this.target.getBoundingClientRect();
        const scroll = Utils.getScrollTop();

        return {
            top   : rect.top + scroll,
            right : rect.right,
            bottom: rect.bottom + scroll,
            left  : rect.left
        };
    }

    _bindContext() {
        this._showTooltip = this._showTooltip.bind(this);
        // this._bindTouch = this._bindTouch.bind(this);
        this._onResize = this._onResize.bind(this);
    }

    /**
     * Вешаем слушателей на нужные контролы
     */
    bindEvents() {
        const esc = 27;

        // Скрыть тултип при ресайзе
        const events = ['resize', 'orientationchange'];

        events.forEach((event) => {
            window.addEventListener(event, this._onResize);
        });

        // Клик по таргету
        document.addEventListener('click', (event) => {
            if (Utils.isMobile() || Utils.isTouch()) {
                if (this._isTarget(event)) {
                    setTimeout(this._showTooltip, 10);
                }
            }
        });

        // Тач
        // document.addEventListener('touchend', this._bindTouch);

        Utils.clickOutside(['.tooltip__content'],
            this._destroyTooltip.bind(this), null, true);

        // Наведение мыши на цель на десктопе без тача
        this.target.addEventListener('mouseenter', (event) => {
            event.preventDefault();
            event.stopPropagation();

            if (this.isDesktop && !Utils.isTouch()) {
                this._showTooltip();
            }
        });

        // Уход мыши с цели на десктопе без тача
        this.target.addEventListener('mouseleave', () => {
            if (this.isDesktop && !Utils.isTouch()) {
                this._hideTooltip();
            }
        });

        this.target.addEventListener('mousemove', (event) => {
            return event;
        });

        document.addEventListener('keydown', (event) => {
            if (event.which === esc) {
                return event;
            }

            return event;
        });
    }

    _bindTouch(event) {
        if ((Utils.isMobile() && event.target.closest('.tooltip__content')) || this._isTarget(event)) {
            return;
        }

        this._destroyTooltip();
    }

    _onResize() {
        this.isDesktop = !Utils.isMobile();
        this._hideTooltip();
    }

    /**
     * Определяет, по элементу произошло событие или нет
     * @param {object} event - событие
     * @returns {boolean} - true - событие на элементе
     * @private
     */
    _isTarget(event) {
        if (this.options.targetSelector) {
            return event.target.closest(this.options.targetSelector) === this.target;
        }

        return event.target === this.target;
    }

    /**
     * Показывает тултип
     * @private
     */
    _showTooltip() {
        this._destroyTooltip();
        this.targetCoords = this.getTargetCoords();
        this._insertTemplate();
    }

    /**
     * Прячет тултип
     * @private
     */
    _hideTooltip() {
        const tooltip = document.querySelector('.j-tooltip');

        if (tooltip) {
            tooltip.classList.add(this.removeClass);
        }

        if (tooltipTimer) {
            this._destroyTooltip();
        } else {
            tooltipTimer = setTimeout(() => {
                this._destroyTooltip();
            }, 50);
        }
    }

    /**
     * Удаляет тултип со страницы и чистит таймер
     * @private
     */
    _destroyTooltip() {
        clearTimeout(tooltipTimer);
        tooltipTimer = null;

        Array.from(document.querySelectorAll('.j-tooltip')).forEach((tooltip) => {
            Utils.removeElement(tooltip);
        });
    }

    /**
     * Создает и вставляет тултип на странице
     * @private
     */
    _insertTemplate() {
        Utils.insetContent(this._getContainer(), this.template({
            content  : this.content,
            direction: this.direction,
            type     : this.options.type,
            left     : this._x(this.direction),
            top      : this._y(this.direction)
        }));
    }

    _getContainer() {
        return document.body;
    }

    _x(direction) {
        let x = 0;
        const halfWidth = 2;
        const targetWidth = this.target.offsetWidth || this.target.getBoundingClientRect().width;

        switch (direction) {
            case 'under':
            case 'over':
                x = this.targetCoords.left + (targetWidth / halfWidth);
                break;
            case 'left':
                x = this.targetCoords.left - this.offset;
                break;
            case 'right':
                x = this.targetCoords.right + this.offset;
                break;
            default:
                x = this.targetCoords.left + (targetWidth / halfWidth);
                break;
        }

        return x;
    }

    _y(direction) {
        let y = 0;
        const halfHeight = 2;
        const targetHeight = this.target.offsetHeight || this.target.getBoundingClientRect().height;

        switch (direction) {
            case 'under':
                y = this.targetCoords.bottom + this.offset;
                break;
            case 'over':
                y = this.targetCoords.top - this.offset;
                break;
            case 'right':
            case 'left':
                y = this.targetCoords.top + (targetHeight / halfHeight);
                break;
            default:
                y = this.targetCoords.bottom + this.offset;
                break;
        }

        return y;
    }
}

export class ImageTooltip extends Tooltip {
    constructor(props) {
        super(props);

        this.activeClass = 'is-active';
    }

    _x() {
        return this.isDesktop ? this.targetCoords.left : 0;
    }

    _y() {
        return this.isDesktop ? this.targetCoords.top : 0;
    }

    _showTooltip() {
        super._showTooltip();
        this.target.classList.add(this.activeClass);
    }

    _hideTooltip() {
        super._hideTooltip();
        this.target.classList.remove(this.activeClass);
    }

    _destroyTooltip() {
        this.target.classList.remove(this.activeClass);
        super._destroyTooltip();
    }

    _getContainer() {
        return this.isDesktop ? document.body : this.options.mobileContainer;
    }
}

